"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledCardBody = exports.StyledCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  padding: 14px;\n  font-family: 'Raleway', sans-serif;\n  font-size: 14px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  box-shadow: 0px 0px 5px rgba(0,0,0,0.15), 0px 5px 5px rgba(0,0,0,0.15);\n  border-radius: 3px;\n  font-family: 'Raleway', sans-serif;\n  font-size: 14px;\n  box-sizing: border-box;\n  background-color: #ffffff;\n  color: #5b5b5b;\n  border: 1px solid transparent;\n\n  &.pui-card--padding {\n    padding: 14px;\n  }\n\n  &.pui-card--selected {\n    background-color: #f1f9fe;\n    border: 1px solid #bde4fb;\n  }\n\n  &.pui-card--clickable {\n    cursor: pointer;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledCard = _styledComponents["default"].div(_templateObject());

exports.StyledCard = StyledCard;

var StyledCardBody = _styledComponents["default"].div(_templateObject2());

exports.StyledCardBody = StyledCardBody;

var Card = function Card(_ref) {
  var selected = _ref.selected,
      padding = _ref.padding,
      clickable = _ref.clickable,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["selected", "padding", "clickable", "className", "children"]);

  var elementProps = _objectSpread({}, props);

  elementProps.className = (0, _clsx["default"])(className, {
    'pui-card--selected': selected,
    'pui-card--padding': padding,
    'pui-card--clickable': clickable
  });
  return /*#__PURE__*/_react["default"].createElement(StyledCard, elementProps, children);
};

Card.propTypes = {
  selected: _propTypes["default"].bool,
  padding: _propTypes["default"].bool,
  clickable: _propTypes["default"].bool
};
Card.defaultProps = {
  selected: false,
  padding: false,
  clickable: false
};
var _default = Card;
exports["default"] = _default;